import dtos from '@/dtos/course';

import {
    RESET_COURSES,
    FETCH_ONE,
    FETCH_NEXT,
    FETCH_EARLIER_COURSES,
    FETCH_LATER_COURSES,
    COURSE_DRAFT_FILL,
    COURSE_DRAFT_INITIALIZE,
    CREATE_DRAFT_COURSE,
} from './types';
import draft from './draft';
import { DEFAULT_DRAFT } from './state';

export default {
    [RESET_COURSES](state) {
        state.next = null;
        state.earlier_courses = [];
        state.earlier_boundary = {
            date: null,
            time: null,
        };
        state.earlier_has_more = true;
        state.later_courses = [];
        state.later_boundary = {
            date: null,
            time: null,
        };
        state.later_has_more = true;
    },
    [FETCH_ONE](state, payload) {
        state.course = dtos.course(payload);
    },
    [FETCH_NEXT](state, payload) {
        state.next = dtos.course(payload);
        state.later_has_more = !!payload;
        if (payload) {
            const { date, end_time } = payload;
            state.later_boundary = {
                date,
                time: end_time,
            };
        }
    },
    [FETCH_EARLIER_COURSES](state, payload) {
        const { courses, earlier_date, earlier_count } = payload;

        state.earlier_courses.push(...courses);
        state.earlier_boundary = {
            date: earlier_date,
            time: null,
        };
        state.earlier_has_more = earlier_count > 0;
    },
    [FETCH_LATER_COURSES](state, payload) {
        const { courses, later_date, later_count } = payload;

        state.later_courses.unshift(...courses.reverse());
        state.later_boundary = {
            date: later_date,
            time: null,
        };
        state.later_has_more = later_count > 0;
    },
    [CREATE_DRAFT_COURSE](state, payload) {
        state.created = payload;
    },
    [COURSE_DRAFT_INITIALIZE](state) {
        state.draft = { ...DEFAULT_DRAFT };
        draft.set(state.draft);
    },
    [COURSE_DRAFT_FILL](state, payload) {
        state.draft = { ...state.draft, ...payload };
        draft.set(state.draft);
    },
};



// WEBPACK FOOTER //
// ./src/store/course/mutations.js